import { GeneralService } from './../../services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { FormularioService } from 'src/app/services/formulario.service';
import { Component, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { GeneralComponent } from 'src/app/shared/general.component';
import { AuthService } from 'src/app/services/auth.guard.service';
import { Credentials } from 'src/app/entity/models/credentials';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})

export class LoginComponent extends GeneralComponent implements OnInit, AfterViewInit {

    public formulario: FormGroup;
    public hideSenha: boolean;
    @ViewChild('txtUsuario') txtUsuario: ElementRef;
    @ViewChild('txtSenha') txtSenha: ElementRef;

    constructor(
        protected formBuilder: FormBuilder,
        protected router: Router,
        protected formularioService: FormularioService,
        protected authService: AuthService,
        protected notificationService: NotificationService,
        protected generalService: GeneralService
    ) {
        super('', true);
        this.formulario = this.formBuilder.group({
            Login: ['', [Validators.required]],
            Senha: ['', [Validators.required]],
        });
    }

    async ngAfterViewInit() {
        this.txtUsuario.nativeElement.focus();
    }

    async ngOnInit() {
        if (this.authService.isAuthenticated()) {
            this.router.navigate(['/dashboard']);
        }
        this.hideSenha = true;
    }

    async login(): Promise<void> {
        const credentials: Credentials = new Credentials();
        credentials.cwid = this.formulario.get('Login')?.value ?? '';
        credentials.password = this.formulario.get('Senha')?.value ?? '';
        if (this.formulario.valid) {
            await this.authService.Login(credentials).pipe(take(1)).toPromise().then(response => {
                this.authService.keepUserData(response);
                // tslint:disable-next-line: max-line-length
                this.notificationService.sendNotificationWithRoute('', TypeMessage.Login, ActionMessage.Success, 'login');
            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, `Falha na autenticação do CWID ${credentials.cwid} para acessar o sistema`);
            });
        } else {
            await this.showNotification();
        }
    }

    private showNotification(): void {
        if (!this.formulario.get('Login').valid && this.formulario.get('Senha').valid) {
            this.notificationService.sendNotification('O campo Login deve ser preenchido para que o acesso seja concluido', TypeMessage.Personalized, ActionMessage.Warning);
            this.txtUsuario.nativeElement.focus();
        } else if (this.formulario.get('Login').valid && !this.formulario.get('Senha').valid) {
            this.notificationService.sendNotification('O campo Senha deve ser preenchido para que o acesso seja concluido', TypeMessage.Personalized, ActionMessage.Warning);
            this.txtSenha.nativeElement.focus();
        } else {
            this.notificationService.sendNotification('O campo Login e Senha devem ser preenchidos para que o acesso seja concluido', TypeMessage.Personalized, ActionMessage.Warning);
            this.txtUsuario.nativeElement.focus();
        }
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }
}